import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik, useFormikContext } from 'formik';

import {
  updateMultipleQueryStringOnFieldChange,
  updateQueryStringOnFieldChange,
} from '@components/Filters/Filters';
import { countryApi } from '@reducers/geo';
import { planApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

const AutoSubmitFilter = () => {
  const formik = useFormikContext();
  useEffect(() => {
    if (!formik.values.plan || !formik.values.country) {
      formik.setTouched({}, false);
    }
  }, [formik.values.plan]);
};

export const EditProfileFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const country = searchParams.get('country') || '';
  const countries = countryApi.useGetForSelectQuery();
  const plan = planApi.useGetForSelectQuery(
    country ? { id: country } : skipToken
  );
  return (
    <Formik
      enableReinitialize
      initialValues={{
        country,
        plan: searchParams.get('plan') || '',
        type: searchParams.get('type') || '',
      }}
      onSubmit={() => {}}
    >
      {({ handleChange, handleBlur, values, setFieldValue }) => (
        <Form>
          <Form.Label>Country</Form.Label>
          <Form.Select
            className="mb-3"
            name="country"
            size="sm"
            value={values.country}
            onChange={(e) => {
              handleChange(e);
              updateQueryStringOnFieldChange(e, {
                searchParams,
                setSearchParams,
                clearFields: ['plan', 'type'],
              });
            }}
            onBlur={handleBlur}
          >
            <option value="">Select country</option>
            {!countries.isLoading &&
            !countries.isError &&
            countries.data.length > 0 ? (
              <>
                {countries.data.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </>
            ) : null}
          </Form.Select>
          <Form.Label>Plan</Form.Label>
          <Form.Select
            className="mb-3"
            name="plan"
            size="sm"
            value={`${values.plan}-${values.type}`}
            disabled={plan.isLoading || plan.isFetching || !values.country}
            onChange={(e) => {
              const { dataset } = e.target.options[e.target.selectedIndex];
              handleChange(
                e.target.name,
                `${e.target.value}-${dataset.plantype}`,
                dataset.plantype
              );
              setFieldValue('type', dataset.plantype || '');

              updateMultipleQueryStringOnFieldChange(
                [
                  { name: e.target.name, value: dataset.planid },
                  { name: 'type', value: dataset.plantype || '' },
                ],
                {
                  searchParams,
                  setSearchParams,
                }
              );
            }}
            onBlur={handleBlur}
          >
            {plan.isLoading ? <option>Loading...</option> : null}
            <option value="">
              {values.country ? 'Select plan' : 'Select country to see plans'}
            </option>

            {!plan.isUninitialized &&
            !plan.isLoading &&
            !plan.isFetching &&
            !plan.isError &&
            plan.data.length > 0
              ? plan.data.map(({ value, name, plan_type: type }) => (
                  <option
                    key={`${value}-${type}-${name}`}
                    value={`${value}-${type}`}
                    data-plantype={type}
                    data-planid={value}
                  >
                    {name}
                  </option>
                ))
              : null}
          </Form.Select>
          <AutoSubmitFilter />
        </Form>
      )}
    </Formik>
  );
};
